module.exports = __webpack_public_path__ + "static/media/icon.65a60f88.png";